import React, { useEffect, useState, useMemo, useReducer } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import Button from '@material-ui/core/Button';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { TextField } from '@material-ui/core';
import { useForm } from 'react-hook-form';
import cls from './step7.module.scss';
import globalParam from '../../../redux/actions/globalParam';
import Spinner from '../../../components/Spinner';

import Packages from './Packages';
import OfferInformation from './component/OfferInformation';

import ticket from '../../../redux/actions/ticket';

import authenticationAction from '../../../redux/actions/authentication';
import Sidebar from '../../Purchase/sidebar';
import errorsHepler from '../../../helpers/errorsHelper';
import PhoneInput from '../../../components/PhoneInput/index';
import TabsLanguage from '../../../components/TabsLanguage/TabsLanguage';

function Step7({ onNext, slugEvent, slugYacht, setTicket, isNotSlideBar }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const history = useHistory();
  const [push, setPushEvent] = useState(false);
  const ticketEditing = useSelector((state) => state.globalParam.ticket);
  const ticketState = useSelector((state) => state.ticket.isRequested); // TODO почистить стор ( из следует обьединить)
  const ticketEventState = useSelector(
    (state) => state.eventsBucket.isRequested,
  ); // TODO почистить стор ( из следует обьединить)
  const authUser = useSelector((state) => state.authentication.user);

  const query = new URLSearchParams(history.location.search);
  const slugEventURL = query.get('slug');
  const locale = useSelector((state) => state.locale);
  const user = useSelector((state) => state.authentication.user);
  const lang = locale.locales;
  const initialValues = {
    description: ticketEditing?.description?.native,
    phone:
      (ticketEditing?.phone && String(ticketEditing?.phone)) ||
      String(user.phone),
    places: ticketEditing?.places,
    places_bet: ticketEditing?.placesBed,
    currency: ticketEditing?.currency || 'EUR',
    dropSelected: ticketEditing?.dropSelected,
    cashDesk: ticketEditing?.commonExpenses?.value,
    cashDeskTeam: ticketEditing?.commonExpenses?.team || 'persone',
    returnDeposit: ticketEditing?.returnDeposit?.value,
    returnDepositTeam: ticketEditing?.returnDeposit?.team || 'persone',
    isChildrenAllowed:
      (ticketEditing?.isChildrenAllowed ? 'yes' : 'no') || 'yes',
    packages: ticketEditing?.packages || [],
    sexGender: ticketEditing?.sexGender || 'unisex',
    lvlPerson: ticketEditing?.lvlPerson || 'any',
  };

  const SETTICKET = 'SETTICKET';
  const reducer = (state, action) => {
    switch (action.type) {
      case SETTICKET:
        return { ...state, ...action.payload };

      default:
        return state;
    }
  };

  const [formValues, setCreateTicket] = useReducer(reducer, initialValues);
  const action = {
    setFormValues: (payload) => setCreateTicket({ type: SETTICKET, payload }),
  };
  const {
    handleSubmit,
    register,
    control,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: initialValues,
  });

  const setTicketForm = (value) =>
    action.setFormValues({ ...formValues, ...value });
  useMemo(() => {
    if (slugEventURL) {
      dispatch(
        globalParam.goCheck(slugEventURL, null, true, (err) => {
          if (err) {
            history.push(
              `/create-event/yacht?slug=${slugEventURL}&addBoatFromEvent=true`,
            );
          }
        }),
      );
    }
    return '';
  }, [dispatch, history, slugEventURL]);

  useEffect(() => () => {}, [dispatch]);

  const onSubmit = (values) => {
    setTicketForm({ ...formValues, ...values });
    if (formValues.syncErrors) {
      return toast(t('validate.validateForm'), { type: toast.TYPE.ERROR });
    }
    let copy = null;
    if (formValues) {
      copy = { ...formValues };
      copy.phone = copy.phone.replace(/[^0-9]/g, '');
    }
    return setTicket
      ? setTicket(copy)
      : dispatch(
          ticket.createTicket(
            copy,
            slugEvent,
            slugYacht,
            push,
            (err, tiket) => {
              if (tiket) {
                if (
                  tiket.success === true &&
                  copy.phone !== String(authUser.phone)
                ) {
                  return dispatch(
                    authenticationAction.updateProfileProperties(
                      { phone: copy.phone },
                      () => {
                        onNext();
                      },
                    ),
                  );
                }
                onNext();
              } else {
                toast(err, { type: toast.TYPE.ERROR });
              }
            },
          ),
        );
  };

  return (
    <section className={cls.step7}>
      <Spinner show={ticketState || ticketEventState} />
      {!setTicket && (
        <>
          <div className={cls.load_container}>
            <span className={cls.load_line} />
          </div>
          <h1 className={cls.headline}>{t('create.step7.title')}</h1>
        </>
      )}
      <div className={`${!isNotSlideBar ? cls.info_box : ''}`}>
        <section className={`widget ${cls.add_info_widget}`}>
          <div className={cls.title_add_info}>
            <h3>{t('create.step7.conditions')}</h3>
          </div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <TabsLanguage
              initialValues={formValues?.description}
              errors={errorsHepler(errors, lang)}
            >
              {(langCildren) => {
                const {
                  onChange: onChangeDescription,
                  ...resDescriptionsProps
                } = register(`description.${langCildren}`, {
                  required: t('form.validate.required'),
                  minLength: {
                    value: 10,
                    message: t('form.validate.formMin', { min: '10' }),
                  },
                });
                return (
                  <>
                    <div className={cls.info_team}>
                      <OfferInformation
                        formValues={formValues}
                        register={register}
                        control={control}
                        errors={errors}
                        setTicketForm={setTicketForm}
                      />
                      <Packages
                        langCildren={langCildren}
                        formValues={formValues}
                        control={control}
                        setTicketForm={setTicketForm}
                        errors={errors}
                        register={register}
                        reset={reset}
                      />
                    </div>
                    <TextField
                      error={!!errors?.description?.[langCildren]}
                      value={formValues?.description?.[langCildren]}
                      label={`${t('create.step7.possible')} *`}
                      onChange={(e) => {
                        onChangeDescription(e);
                        setTicketForm({
                          description: {
                            ...formValues.description,
                            [langCildren]: e.target.value,
                          },
                        });
                      }}
                      placeholder={t('create.step7.descriptionValue')}
                      name={`description.${langCildren}`}
                      fullWidth
                      multiline
                      rows={2}
                      autoComplete="off"
                      variant="outlined"
                      {...resDescriptionsProps}
                      helperText={
                        errors?.description?.[langCildren]
                          ? errors?.description?.[langCildren].message
                          : ''
                      }
                    />
                  </>
                );
              }}
            </TabsLanguage>
            <div className={cls.how_much_container}>
              <div className={cls.how_much}>
                <PhoneInput
                  t={t}
                  error={!!errors.phone}
                  value={formValues?.phone}
                  register={register}
                  defaultCountry="cy"
                  name="phone"
                  label={`${t('create.step3.phone')} ( ${t(
                    'create.step3.phoneDescrip',
                  )} ) *`}
                  placeholder={t('create.step3.phoneExemp')}
                  helperText={errors.phone ? errors.phone.message : ''}
                  fullWidth
                  autoComplete="off"
                  variant="outlined"
                />
              </div>
            </div>
            <div className={cls.showing_help}>
              <span>{t('create.step7.remember_helping')}</span>
            </div>
            <div className={cls.save}>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                size="large"
                onClick={() => setPushEvent(true)}
              >
                {ticketEditing && ticketEditing.statusTicket
                  ? t('create.step7.edit')
                  : t('create.step7.post')}
              </Button>
            </div>
          </form>
        </section>
        {!isNotSlideBar && <Sidebar slugEvent={slugEvent} />}
      </div>
    </section>
  );
}

Step7.propTypes = {
  slugEvent: PropTypes.string.isRequired,
  slugYacht: PropTypes.string,
  onNext: PropTypes.func,
  setTicket: PropTypes.func,
  isNotSlideBar: PropTypes.bool,
};

Step7.defaultProps = {
  onNext: () => {},
  setTicket: null,
  slugYacht: '',
  isNotSlideBar: false,
};

export default Step7;
